import PageMamas from '../../Components/Mamas-page/mamas';
import Agendamento from '../../Components/Banner-Agendamentos/BanAgendamentos';
import Footer from '../../Components/Footer/Footer';

function Mamas() {
  return (
    <>
      <div id="Mamas">
        <PageMamas />
      </div>
      <div id="Agendamento">
        <Agendamento />
      </div>
      <div id="Footer">
        <Footer />
      </div>
    </>
  );
}

export default Mamas;
